/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';

import { useAdminRevokeOtpVerificationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useAdminRevokeOtpVerification = () => {
  const [handle, { data, loading, error: apolloError }] =
    useAdminRevokeOtpVerificationMutation();

  const error = useError(apolloError);

  return {
    error,
    loading,
    data: data?.revokeOtpVerification,
    revokeOtpVerification: useCallback(
      async (userId: string) => {
        const res = await handle({ variables: { id: userId } });

        return !!res.data?.revokeOtpVerification;
      },
      [handle]
    ),
  };
};
